module.exports = __webpack_public_path__ + "img/ic_dlf@2x.7976c07b.png";